var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1268_1030)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 4,
    fill: "#FAF7FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1268_1030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7939 25.2316C27.9994 20.9017 22.3655 19.4806 21.6191 19.3252C20.0541 20.4576 17.8391 20.4576 16.2741 19.3252C15.5277 19.4806 10.0142 20.8795 9.21966 25.2316C8.81036 27.0524 8.93074 28.6067 9.94196 28.9176C10.5439 29.0952 11.531 28.8731 12.5904 28.5623C12.6145 28.5623 12.6145 28.5623 12.6385 28.5401H12.6626C13.3127 28.3402 13.7701 27.7851 13.7701 27.1412V27.0746C13.7701 26.5195 13.4331 26.031 12.9515 25.7867C13.7942 23.4774 16.1778 21.8343 18.9948 21.8343C21.7876 21.8343 24.1712 23.4996 25.0621 25.8089C24.5805 26.0754 24.2435 26.5417 24.2435 27.0968V27.1634C24.2435 27.8295 24.725 28.3846 25.3751 28.5845C26.4585 28.8731 27.4216 29.1174 27.9994 28.9398C29.0347 28.6511 29.2032 27.0524 28.7939 25.2316Z",
    fill: "#8362E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0188 19.1253C21.9043 19.1253 24.2435 16.8587 24.2435 14.0627C24.2435 11.2666 21.9043 9 19.0188 9C16.1334 9 13.7942 11.2666 13.7942 14.0627C13.7942 16.8587 16.1334 19.1253 19.0188 19.1253Z",
    fill: "#8362E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.656 26.8747C20.8246 27.1412 20.9209 27.4298 20.9209 27.7629C20.9209 28.1626 20.7764 28.5179 20.5357 28.8065C21.8599 28.7399 22.9674 28.5845 23.9064 28.3846C23.9305 28.1848 23.9545 27.9628 23.9545 27.7407C23.9545 26.6527 23.5452 25.6757 22.8711 24.8763L20.656 26.8747Z",
    fill: "#8362E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 26.8747L15.1425 24.8985C14.4443 25.6757 14.035 26.6749 14.035 27.7629C14.035 27.985 14.0591 28.207 14.0831 28.4069C15.0221 28.6067 16.1296 28.7399 17.4539 28.8065C17.2131 28.5179 17.0686 28.1404 17.0686 27.7629C17.0686 27.4298 17.1649 27.119 17.3335 26.8747Z",
    fill: "#8362E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9948 26.8747C18.4651 26.8747 18.0317 27.2744 18.0317 27.7629C18.0317 28.2514 18.4651 28.6511 18.9948 28.6511C19.5244 28.6511 19.9578 28.2514 19.9578 27.7629C19.9578 27.2744 19.5244 26.8747 18.9948 26.8747Z",
    fill: "#8362E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9948 23.1888C17.7669 23.1888 16.6593 23.5884 15.7926 24.2768L18.0076 26.253C18.2965 26.0976 18.6336 26.0088 18.9948 26.0088C19.3559 26.0088 19.7171 26.0976 20.006 26.2752L22.221 24.299C21.3302 23.6107 20.2227 23.1888 18.9948 23.1888Z",
    fill: "#8362E5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1268_1030",
    x: -7,
    y: 1,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.278431 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1268_1030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1268_1030",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1268_1030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignDriver);
export default __webpack_public_path__ + "static/media/AssignDriver.4890b01f7c32dffd0de37899e8f7cb01.svg";
export { ForwardRef as ReactComponent };